import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  Button,
  Box,
  TextField,
  TablePagination,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Card,
  CardContent,
  Grid,
  Switch,
  FormControlLabel,
  MenuItem,
  Divider
} from '@mui/material';
import baseURL from '../config';
import Navbar from '../Navbar/Navbar';
import VisibilityIcon from '@mui/icons-material/Visibility';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import { IconButton, Tooltip } from '@mui/material';
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const AllAdminCrewing = () => {
  const [formData, setFormData] = useState({
    currency: "USD",
    manningFeeForNewJoinerApplicable: false,
    manningFeeForNewJoiner: { seniorOfficer: 0, juniorOfficer: 0, rating: 0 },
    manningFeeForRejoinerApplicable: false,
    manningFeeForRejoiner: { seniorOfficer: 0, juniorOfficer: 0, rating: 0 },
    manningFeeForOwnerProposedApplicable: false,
    manningFeeForOwnerProposed: { seniorOfficer: 0, juniorOfficer: 0, rating: 0 },
    oneTimeFindesFeeApplicable: false,
    oneTimeFindesFee: 0,
    retentionFeeApplicable: false,
    retentionFee: { amount: 0, perDayOrPerMonth: "perMonth" },
    crewWelfareApplicable: false,
    crewWelfare: { amount: 0, perDayOrPerMonth: "perMonth" },
  });
  const [crewingAgents, setCrewingAgents] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [openModal, setOpenModal] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [fetchSelectedAgentDetails, setFetchSelectedAgentDetails] = useState([])
  const [invoiceData, setInvoiceData] = useState({
    JoinerWithCrewWelfare: '',
    RejionerWithCrewWelfare: '',
    JoinerWithoutCrewWelfare: '',
    RejionerWithoutCrewWelfare: '',
  });
  const navigate = useNavigate();
  const creatorId = localStorage.getItem("user id");
  const [openBankModal, setOpenBankModal] = useState(false);
  const [bankDetails, setBankDetails] = useState({
    bankName: '',
    accountNumber: '',
    ifscCode: '',
    branchName: '',
    bankAdress: '',
  });

  useEffect(() => {
    const fetchCrewingAgents = async () => {
      const token = localStorage.getItem("token");
      try {
        const response = await axios.get(`${baseURL}/api/getcrewingAgentDetails`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setCrewingAgents(response.data);
        // console.log("gdjdg", response.data)
      } catch (error) {
        console.error('Error fetching crewing agents:', error);
      }
    };

    // const fetchSelectedAgentDetails = async () => {
    //   const response = await axios.get(
    //             `${baseURL}/api/getCrewingAgentsDetailsById/${selectedAgent}`,
    //             { headers: { Authorization: `Bearer ${token}` } }
    //           );
    //           setFetchSelectedAgentDetails(response.data);
    //           console.log("setFetchSelectedAgentDetails", response.data)
    // }

    fetchCrewingAgents();
    // fetchSelectedAgentDetails();
  }, []);

  useEffect(() => {
    const fetchSelectedAgentDetails = async () => {
      try {
        const token = localStorage.getItem("token");
        console.log("selectedAgent", selectedAgent)
        const response = await axios.get(
          `${baseURL}/api/getCrewingAgentsDetailsById/${selectedAgent}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setFetchSelectedAgentDetails(response.data);
        console.log("setFetchSelectedAgentDetails:", response.data);
      } catch (error) {
        console.error("Error fetching agent details:", error);
      }
    };

    if (selectedAgent) {
      fetchSelectedAgentDetails(); 
    }
  }, [selectedAgent]);


  const handleOpenModal = (agentId) => {
    setSelectedAgent(agentId);
    console.log("agentId", agentId)
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setInvoiceData({
      JoinerWithCrewWelfare: '',
      RejionerWithCrewWelfare: '',
      JoinerWithoutCrewWelfare: '',
      RejionerWithoutCrewWelfare: '',
    });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setInvoiceData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleToggle = (field) => {
    setFormData(prev => ({ ...prev, [field]: !prev[field] }));
  };

  const handleChange = (field, value, subField = null) => {
    if (subField) {
      setFormData(prev => ({
        ...prev,
        [field]: { ...prev[field], [subField]: value }
      }));
    } else {
      setFormData(prev => ({ ...prev, [field]: value }));
    }
  };



  // const handleSubmit = async () => {

  //   try {
  //     const payload = {
  //       crewingAgentId: selectedAgent, // Passing selected Agent ID
  //       JoinerWithCrewWelfare: invoiceData.JoinerWithCrewWelfare,
  //       RejionerWithCrewWelfare: invoiceData.RejionerWithCrewWelfare,
  //       JoinerWithoutCrewWelfare: invoiceData.JoinerWithoutCrewWelfare,
  //       RejionerWithoutCrewWelfare: invoiceData.RejionerWithoutCrewWelfare,
  //       creatorId: creatorId, // Ensure this is set correctly
  //     };

  //     const token = localStorage.getItem("token");

  //     const response = await axios.post(`${baseURL}/api/createChargesForCrewingAgent`, payload,
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );


  //     toast.success("Charges created successfully!");

  //     // Close the modal after submission
  //     handleCloseModal();

  //   } catch (error) {
  //     console.error("Error creating charges:", error.response?.data || error.message);
  //     toast.error("Failed to create charges. Please try again.");
  //   }
  // };

  const handleSubmit = async () => {
    try {
      const token = localStorage.getItem("token");
      const urlID = localStorage.getItem("urlID");
      const UserId = localStorage.getItem("user id");
      const userType = localStorage.getItem("userType")


      const payload = {
        ...formData,
        crewingAgentId: fetchSelectedAgentDetails?._id, // get from selected agent or props
        crewingAgentName: fetchSelectedAgentDetails?.agentName,
        creatorId: UserId,
        creatorName: userType  // get from logged-in user
      };

      const res = await axios.post(
        `${baseURL}/api/createChargesForCrewingAgent`, // update baseURL if needed
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json"
          }
        }
      );

      toast.success("Charges saved successfully!");
      console.log("API Response:", res.data);
      window.location.reload();
    } catch (err) {
      console.error("API Error:", err);
      toast.error(err.response?.data?.message || "Something went wrong");
    }
  };

  const filteredAgents = crewingAgents
    .filter((agent) =>
      agent.agentName.toLowerCase().includes(searchTerm.toLowerCase())
    )
    .sort((a, b) => a.agentName.localeCompare(b.agentName));

  const handleOpenBankModal = (agentId) => {
    setSelectedAgent(agentId);
    setOpenBankModal(true);
  };



  const handleCloseBankModal = () => {
    setOpenBankModal(false);
    setBankDetails({
      bankName: '',
      accountNumber: '',
      ifscCode: '',
      branchName: '',
      bankAdress: '',
    });
  };

  const handleBankInputChange = (e) => {
    const { name, value } = e.target;
    setBankDetails((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleBankSubmit = async () => {


    const payload = {
      crewingAgentId: selectedAgent,
      accountNumber: bankDetails.accountNumber,
      bankName: bankDetails.bankName,
      ifscCode: bankDetails.ifscCode,
      branchName: bankDetails.branchName,
      bankAdress: bankDetails.bankAdress,
      BankHolderName: bankDetails.BankHolderName,
    }

    try {
      const token = localStorage.getItem("token");
      const bankDetails = await axios.post(`${baseURL}/api/CrewinngAccount/CrewingAgentAccount`, payload, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
      })
      toast.success("data saved succesfully")
      setTimeout(() => {
        window.location.reload();
      }, 1000);

    } catch (err) {
      // console.log(err)
    }


  }


  return (
    <>
      <Navbar />
      <div style={{ padding: '24px' }}>
        <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 2 }}>
          <TextField
            label="Search by Name"
            variant="outlined"
            size="small"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            sx={{ width: '300px' }}
          />
          <Typography variant="h4" sx={{ flexGrow: 1, textAlign: "center", mr: "300px" }}>
            Crewing Agents List
          </Typography>
        </Box>

        <TableContainer component={Paper}>
          <Table>
            <TableHead sx={{ backgroundColor: "#1976D2", height: "30px", "& th": { color: "white", fontWeight: "bold" } }}>
              <TableRow>
                <TableCell><strong>Sr. No.</strong></TableCell>
                <TableCell><strong>Name</strong></TableCell>
                <TableCell><strong>Email</strong></TableCell>
                <TableCell><strong>Short Name</strong></TableCell>
                <TableCell><strong>Actions</strong></TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredAgents
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((agent, index) => (
                  <TableRow key={agent._id}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{agent.agentName}</TableCell>
                    <TableCell>{agent.email}</TableCell>
                    <TableCell>{agent.shortName}</TableCell>
                    <TableCell>
                      <Tooltip title="View Details">
                        <IconButton onClick={() => navigate(`/crew-agent/${agent._id}`)} color="primary">
                          <VisibilityIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Charges">
                        <IconButton onClick={() => handleOpenModal(agent._id)} color="primary">
                          <MonetizationOnIcon />
                        </IconButton>
                      </Tooltip>

                      <Tooltip title="Bank Details">
                        <IconButton onClick={() => handleOpenBankModal(agent._id)} color="secondary">
                          <AccountBalanceIcon />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
              {filteredAgents.length === 0 && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    No matching records found.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[5, 10, 25]}
          component="div"
          count={filteredAgents.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={(event, newPage) => setPage(newPage)}
          onRowsPerPageChange={(event) => {
            setRowsPerPage(parseInt(event.target.value, 10));
            setPage(0);
          }}
        />
      </div>

      {/* Modal for Invoice Input */}
      <Dialog open={openModal} onClose={handleCloseModal} maxWidth="md" >
        <DialogTitle>Enter Contract Charges</DialogTitle>
        <DialogContent>
          <Box sx={{ maxWidth: 1200, mx: "auto", mt: 6, px: 2 }}>
            <Card sx={{ p: 3, borderRadius: 3, boxShadow: 4 }}>
              <CardContent>
                <Typography variant="h5" sx={{ mb: 3, fontWeight: "bold", color: "primary.main" }}>
                  Charges for Crewing Agent
                </Typography>

                {/* Currency */}
                <TextField
                  label="Currency"
                  select
                  value={formData.currency}
                  onChange={(e) => handleChange("currency", e.target.value)}
                  fullWidth
                  margin="normal"
                  sx={{ mb: 3 }}
                >
                  <MenuItem value="USD">USD</MenuItem>
                  <MenuItem value="EUR">EUR</MenuItem>
                  <MenuItem value="INR">INR</MenuItem>
                </TextField>

                <Divider sx={{ my: 2 }} />

                {/* Manning Fee for New Joiner */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.manningFeeForNewJoinerApplicable}
                      onChange={() => handleToggle("manningFeeForNewJoinerApplicable")}
                    />
                  }
                  label={<Typography fontWeight="600">Manning Fee For New Joiner</Typography>}
                />
                {formData.manningFeeForNewJoinerApplicable && (
                  <Grid container spacing={2} mb={3}>
                    {["seniorOfficer", "juniorOfficer", "rating"].map((rank) => (
                      <Grid item xs={12} sm={4} key={rank}>
                        <TextField
                          label={rank}
                          type="number"
                          fullWidth
                          size="small"
                          value={formData.manningFeeForNewJoiner[rank]}
                          onChange={(e) => handleChange("manningFeeForNewJoiner", e.target.value, rank)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}

                <Divider sx={{ my: 2 }} />

                {/* Manning Fee for Rejoiner */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.manningFeeForRejoinerApplicable}
                      onChange={() => handleToggle("manningFeeForRejoinerApplicable")}
                    />
                  }
                  label={<Typography fontWeight="600">Manning Fee For Rejoiner</Typography>}
                />
                {formData.manningFeeForRejoinerApplicable && (
                  <Grid container spacing={2} mb={3}>
                    {["seniorOfficer", "juniorOfficer", "rating"].map((rank) => (
                      <Grid item xs={12} sm={4} key={rank}>
                        <TextField
                          label={rank}
                          type="number"
                          fullWidth
                          size="small"
                          value={formData.manningFeeForRejoiner[rank]}
                          onChange={(e) => handleChange("manningFeeForRejoiner", e.target.value, rank)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}

                <Divider sx={{ my: 2 }} />

                {/* Manning Fee for Owner Proposed */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.manningFeeForOwnerProposedApplicable}
                      onChange={() => handleToggle("manningFeeForOwnerProposedApplicable")}
                    />
                  }
                  label={<Typography fontWeight="600">Manning Fee For Owner Proposed</Typography>}
                />
                {formData.manningFeeForOwnerProposedApplicable && (
                  <Grid container spacing={2} mb={3}>
                    {["seniorOfficer", "juniorOfficer", "rating"].map((rank) => (
                      <Grid item xs={12} sm={4} key={rank}>
                        <TextField
                          label={rank}
                          type="number"
                          fullWidth
                          size="small"
                          value={formData.manningFeeForOwnerProposed[rank]}
                          onChange={(e) => handleChange("manningFeeForOwnerProposed", e.target.value, rank)}
                        />
                      </Grid>
                    ))}
                  </Grid>
                )}

                <Divider sx={{ my: 2 }} />

                {/* One Time Finders Fee */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.oneTimeFindesFeeApplicable}
                      onChange={() => handleToggle("oneTimeFindesFeeApplicable")}
                    />
                  }
                  label={<Typography fontWeight="600">One Time Finders Fee</Typography>}
                />
                {formData.oneTimeFindesFeeApplicable && (
                  <TextField
                    label="Amount"
                    type="number"
                    fullWidth
                    margin="normal"
                    size="small"
                    sx={{ mb: 3 }}
                    value={formData.oneTimeFindesFee}
                    onChange={(e) => handleChange("oneTimeFindesFee", e.target.value)}
                  />
                )}

                <Divider sx={{ my: 2 }} />

                {/* Retention Fee */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.retentionFeeApplicable}
                      onChange={() => handleToggle("retentionFeeApplicable")}
                    />
                  }
                  label={<Typography fontWeight="600">Retention Fee</Typography>}
                />
                {formData.retentionFeeApplicable && (
                  <Grid container spacing={2} mb={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Amount"
                        type="number"
                        fullWidth
                        size="small"
                        value={formData.retentionFee.amount}
                        onChange={(e) => handleChange("retentionFee", e.target.value, "amount")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        select
                        label="Per Day/Per Month"
                        fullWidth
                        size="small"
                        value={formData.retentionFee.perDayOrPerMonth}
                        onChange={(e) => handleChange("retentionFee", e.target.value, "perDayOrPerMonth")}
                      >
                        <MenuItem value="perDay">Per Day</MenuItem>
                        <MenuItem value="perMonth">Per Month</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                )}

                <Divider sx={{ my: 2 }} />

                {/* Crew Welfare */}
                <FormControlLabel
                  control={
                    <Switch
                      checked={formData.crewWelfareApplicable}
                      onChange={() => handleToggle("crewWelfareApplicable")}
                    />
                  }
                  label={<Typography fontWeight="600">Crew Welfare</Typography>}
                />
                {formData.crewWelfareApplicable && (
                  <Grid container spacing={2} mb={3}>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        label="Amount"
                        type="number"
                        fullWidth
                        size="small"
                        value={formData.crewWelfare.amount}
                        onChange={(e) => handleChange("crewWelfare", e.target.value, "amount")}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <TextField
                        select
                        label="Per Day/Per Month"
                        fullWidth
                        size="small"
                        value={formData.crewWelfare.perDayOrPerMonth}
                        onChange={(e) => handleChange("crewWelfare", e.target.value, "perDayOrPerMonth")}
                      >
                        <MenuItem value="perDay">Per Day</MenuItem>
                        <MenuItem value="perMonth">Per Month</MenuItem>
                      </TextField>
                    </Grid>
                  </Grid>
                )}

                <Box textAlign="center" mt={4}>
                  <Button
                    variant="contained"
                    color="primary"
                    size="large"
                    sx={{ px: 5, borderRadius: 2 }}
                    onClick={handleSubmit}
                  >
                    Save Charges
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </Box>
        </DialogContent>

      </Dialog>

      {/* Bank Details Modal */}
      <Dialog open={openBankModal} onClose={handleCloseBankModal} maxWidth="sm">
        <DialogTitle>Enter Bank Details</DialogTitle>
        <DialogContent>
          <TextField label="Bank Name" fullWidth margin="dense" name="bankName" value={bankDetails.bankName} onChange={handleBankInputChange} />
          <TextField label="Account Holder Name" fullWidth margin="dense" name="BankHolderName" value={bankDetails.BankHolderName} onChange={handleBankInputChange} />
          <TextField label="Account Number" fullWidth margin="dense" name="accountNumber" value={bankDetails.accountNumber} onChange={handleBankInputChange} />
          <TextField label="IFSC" fullWidth margin="dense" name="ifscCode" value={bankDetails.ifscCode} onChange={handleBankInputChange} />
          <TextField label="Branch" fullWidth margin="dense" name="branchName" value={bankDetails.branchName} onChange={handleBankInputChange} />
          <TextField label="Bank Address" fullWidth margin="dense" name="bankAdress" value={bankDetails.bankAdress} onChange={handleBankInputChange} />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseBankModal}>Cancel</Button>
          <Button onClick={handleBankSubmit} variant="contained" color="primary">Submit</Button>
        </DialogActions>
      </Dialog>

      <ToastContainer />
    </>
  );
};

export default AllAdminCrewing;
